<template>
  <div class="atom-indicator-progress">
    <div class="atom-indicator-progress__bar">
      <div
        class="atom-indicator-progress__progress"
        :style="`--current-progress: ${progress}%`"
      />
    </div>

    <div
      v-if="!hideText"
      class="atom-indicator-progress__text"
    >
      {{ progress }}%
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    progress: {
        type: Number,
        default: 0,
    },

    colors: {
        type: Array,
        default: () => [
            {
                start: 0,
                end: 0,
                value: 'var(--c-progress-0)',
            },
            {
                start: 1,
                end: 24,
                value: 'var(--c-progress-1)',
            },
            {
                start: 25,
                end: 49,
                value: 'var(--c-progress-25)',
            },
            {
                start: 50,
                end: 74,
                value: 'var(--c-progress-50)',
            },
            {
                start: 75,
                end: 100,
                value: 'var(--c-progress-75)',
            },
        ],
    },

    backgroundColor: {
        type: String,
        default: '--c-progress--bg',
    },

    hideText: {
        type: Boolean,
        default: false,
    },
});

const { backgroundColor, colors, progress } = toRefs(props);

const currentBarColor = computed(() => {
    const color = colors.value.find(
        (item) => progress.value >= item.start && progress.value <= item.end,
    );
    return color ? color.value : backgroundColor.value;
});

const currentBackgroundColor = computed(
    () => (progress.value === 0 ? currentBarColor.value : backgroundColor.value),
);
</script>

<style lang="scss" scoped>
.atom-indicator-progress {
    @include fluid-simple('column-gap', 20px, 30px);
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
}

.atom-indicator-progress__bar {
    height: 6px;
    flex-grow: 1;
    border-radius: var(--b-radius--full);
    background: v-bind(currentBackgroundColor);
}

.atom-indicator-progress__progress {
    width: var(--current-progress);
    height: 100%;
    border-radius: var(--b-radius--full);
    background-color: v-bind(currentBarColor);
    transition: width 0.5s var(--ease-in-out--quart);
}

.atom-indicator-progress__text {
    color: v-bind(currentBarColor);
    font-family: var(--f-family--primary);
    font-size: var(--f-size--value);
    font-weight: var(--f-weight--900);
}
</style>
